import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { useAiAppraisalToggle } from '@/helpers/aiAppraisalToggle'
import { getStoryBlokLink } from '@/helpers/getStoryBlokLink'
import {
  CtaButtonStoryblok,
  HeaderLinkStoryblok,
} from '@/types/storyblok-component-types'

type NavigationBarItem = HeaderLinkStoryblok | CtaButtonStoryblok

/**
 * Injects the "AI Wert-Check" entry into the Storyblok-driven navigation bar
 * (after "Pfandkredit") while the rollout toggle is on for this visitor.
 */
export function useNavigationBarWithAiWertCheck(
  items?: NavigationBarItem[],
): NavigationBarItem[] | undefined {
  const { t } = useTranslation()
  const enabled = useAiAppraisalToggle()

  return useMemo(() => {
    if (!enabled || !items) {
      return items
    }

    const wertCheckItem: HeaderLinkStoryblok = {
      _uid: 'ai-wert-check-nav-item',
      component: 'header_link',
      caption: t('common:header.ai_wert_check'),
      link: { linktype: 'url', url: '/wert-check', fieldtype: 'multilink' },
    }

    const pawnLoanIndex = items.findIndex((item) => {
      if (item.component !== 'header_link') return false
      const link = getStoryBlokLink(item.link).replace(/\/$/, '')
      return (
        link === 'pfandkredit' ||
        link.endsWith('/pfandkredit') ||
        item.caption?.trim().toLowerCase() === 'pfandkredit'
      )
    })

    return [
      ...items.slice(0, pawnLoanIndex + 1),
      wertCheckItem,
      ...items.slice(pawnLoanIndex + 1),
    ]
  }, [enabled, items, t])
}
